unable to read source [project]/node_modules/src/camera/retriever.ts